/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_share_twitter_tooltip19 = /** @type {(inputs: {}) => string} */ () => {
	return `Share on Twitter`
};

const fr_share_twitter_tooltip19 = /** @type {(inputs: {}) => string} */ () => {
	return `Partager sur Twitter`
};

const de_share_twitter_tooltip19 = /** @type {(inputs: {}) => string} */ () => {
	return `Auf Twitter teilen`
};

const es_share_twitter_tooltip19 = /** @type {(inputs: {}) => string} */ () => {
	return `Compartir en Twitter`
};

const it_share_twitter_tooltip19 = /** @type {(inputs: {}) => string} */ () => {
	return `Condividi su Twitter`
};

const ar_share_twitter_tooltip19 = /** @type {(inputs: {}) => string} */ () => {
	return `شارك على تويتر`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const share_twitter_tooltip19 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.share_twitter_tooltip19(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("share_twitter_tooltip19", locale)
	if (locale === "en") return en_share_twitter_tooltip19(inputs)
	if (locale === "fr") return fr_share_twitter_tooltip19(inputs)
	if (locale === "de") return de_share_twitter_tooltip19(inputs)
	if (locale === "es") return es_share_twitter_tooltip19(inputs)
	if (locale === "it") return it_share_twitter_tooltip19(inputs)
	return ar_share_twitter_tooltip19(inputs)
};
export { share_twitter_tooltip19 as "SHARE_TWITTER_TOOLTIP" }